import React from "react";

const DistibuteIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.021"
      height="24.876"
      viewBox="0 0 27.021 24.876"
    >
      <g id="db35" transform="translate(-2.505 -6.25)">
        <path
          id="Path_1268"
          data-name="Path 1268"
          d="M33.258,31.5v2.048a2.077,2.077,0,0,1-4.153,0V31.5l-5.4,3.214,7.481,4.494,7.481-4.466Z"
          transform="translate(-15.166 -18.067)"
          fill={fill ? fill : "#764bf1"}
        />
        <path
          id="Path_1269"
          data-name="Path 1269"
          d="M55.516,53.4a2.089,2.089,0,0,1,2.845-.768l1.821,1.053V47.6L52.7,52.066v8.648l5.575-3.328-1.991-1.166A2.049,2.049,0,0,1,55.516,53.4Z"
          transform="translate(-35.917 -29.588)"
          fill={fill ? fill : "#764bf1"}
        />
        <path
          id="Path_1270"
          data-name="Path 1270"
          d="M20.9,53.687l1.821-1.053a2.091,2.091,0,1,1,2.105,3.613l-1.991,1.138,5.575,3.328V52.066L20.9,47.6Z"
          transform="translate(-13.163 -29.588)"
          fill={fill ? fill : "#764bf1"}
        />
        <path
          id="Path_1271"
          data-name="Path 1271"
          d="M39.719,10.1l1.166-1.166v6.571a.8.8,0,0,0,.8.8.778.778,0,0,0,.8-.8V8.91l1.166,1.166a.774.774,0,1,0,1.081-1.109l-2.5-2.5a.828.828,0,0,0-1.109,0l-2.5,2.5a.773.773,0,0,0,0,1.109A.8.8,0,0,0,39.719,10.1Z"
          transform="translate(-25.667 0)"
          fill={fill ? fill : "#764bf1"}
        />
        <path
          id="Path_1272"
          data-name="Path 1272"
          d="M6.912,74.088l-1.593-.427,5.689-3.271a.79.79,0,0,0-.8-1.365L4.523,72.3,4.95,70.7a.783.783,0,0,0-1.508-.427l-.91,3.442a.8.8,0,0,0,.54.967l3.442.91a.484.484,0,0,0,.2.028.82.82,0,0,0,.768-.569A.789.789,0,0,0,6.912,74.088Z"
          transform="translate(0 -44.839)"
          fill={fill ? fill : "#764bf1"}
        />
        <path
          id="Path_1273"
          data-name="Path 1273"
          d="M75.086,73.718l-.91-3.442a.783.783,0,1,0-1.508.427l.427,1.593-5.689-3.271a.79.79,0,1,0-.8,1.365L72.3,73.661l-1.593.427a.783.783,0,0,0,.228,1.536.484.484,0,0,0,.2-.028l3.442-.91A.8.8,0,0,0,75.086,73.718Z"
          transform="translate(-45.587 -44.839)"
          fill={fill ? fill : "#764bf1"}
        />
      </g>
    </svg>
  );
};

export default DistibuteIcon;
